"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bemCompose = bemCompose;
exports.bem = bem;
exports.formatMultiline = formatMultiline;
exports.renderNested = renderNested;
exports.renderImageMeta = renderImageMeta;
exports.renderSwitch = renderSwitch;
var _react = _interopRequireDefault(require("react"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _trim2 = _interopRequireDefault(require("lodash/trim"));
function bemCompose(block) {
  var elementOrBlockModifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var elementModifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var base = block;
  var modifiers;
  if ((0, _isObject2.default)(elementOrBlockModifiers)) {
    modifiers = elementOrBlockModifiers;
  } else {
    base += '__' + elementOrBlockModifiers;
    modifiers = elementModifiers;
  }
  var result = base;
  for (var modifier in modifiers) {
    // eslint-disable-line no-restricted-syntax
    var value = modifiers[modifier];
    if (value) {
      result += ' ' + base + '_' + modifier;
      if ((0, _isString2.default)(value)) {
        result += '_' + value;
      }
    }
  }
  return result;
}
function bem(block) {
  return function (elementOrBlockModifiers, elementModifiers) {
    return bemCompose(block, elementOrBlockModifiers, elementModifiers);
  };
}
function formatMultiline(value) {
  return (0, _trim2.default)(value).split(/\n *\n/g).map(function (paragraph) {
    return _react.default.createElement("p", {
      style: {
        whiteSpace: 'pre-line'
      }
    }, paragraph);
  });
}
/**
 * This is a design time util. Do not translate
 */

function renderNested(value) {
  if ((0, _isObject2.default)(value)) {
    if (value.title) return value.title;
    if (value.subject) return value.subject;
    if (value.name) return value.name;
    if (value.email) return value.email;
    if (value.id) return value.id;
    var keys = Object.keys(value);
    return keys.length ? "".concat(keys[0], ": ").concat(value[keys[0]]) : 'Empty';
  }
  if (value == null) {
    return 'None';
  }
  return value;
}
function renderImageMeta(value, alt, className) {
  return value && _react.default.createElement("img", {
    src: value.url,
    width: value.width,
    height: value.height,
    alt: alt,
    className: className
  });
}
function renderSwitch(value, options) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var result = (0, _has2.default)(options, value) ? options[value] : defaultValue;
  return (0, _isFunction2.default)(result) ? result() : result;
}